import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=d464fd1a&scoped=true&"
import script from "./Slider.vue?vue&type=script&lang=js&"
export * from "./Slider.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/slider/Slider/SliderStyle.css?vue&type=style&index=0&id=d464fd1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d464fd1a",
  null
  
)

export default component.exports